<template>
    <div
        class="md-content richtext"
        v-if="contentHtml"
        :style="{ marginBottom, backgroundColor }"
    >
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileNoMargin="mobileNoMargin"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
            noPadding
            noMargin
            v-animated-number="{ duration: 3000, enable: showAnimationEffects }"
            v-animated="animationEffects"
        >
            <renderHtml
                class="custom-richtext-content"
                :innerHTML="contentHtml"
            />
        </module-box>
    </div>
</template>
<script>
import { colorBlock } from '../../defaultSpacing';
import util from '@/common/util';

import { renderHtml } from '@/common/utils/decode-html';

export default {
    components: {
        renderHtml
    },
    data: function() {
        return {
            ...colorBlock,
            css: '',
            html: '',
            isClient: util.isClient,
            animationList: []
        };
    },
    computed: {
        isMobileSize() {
            return this.platform.isMobile;
        },
        paddingTop() {
            return (
                (this.isMobileSize ? this.mobileTopSpacing : this.topSpacing) +
                'px'
            );
        },
        marginBottom() {
            return (
                (this.isMobileSize ? this.mobileBtmSpacing : this.btmSpacing) +
                'px'
            );
        },
        backgroundColor() {
            return this.backgroundColor;
        },
        contentHtml({ css, html }) {
            if (css) {
                html = `<style>${css}</style>` + html;
            }
            return html;
        },
        animationEffects() {
            return this.animationList.map(item => ({
                ...item,
                duration: item.name == 'fade-in' ? 1500 : 1000,
                enable: this.showAnimationEffects
            }))
        }
    },
    mounted() {
        this.$nextTick(() => {
            const itemImg3 = this.$el.querySelector('#richtext-layout16 #item-img3');
            if (itemImg3) {
                const ancestor = itemImg3.closest('.richtext');
                if (ancestor) {
                    const syncBgColor = () => {
                        const ancestorBgColor = window.getComputedStyle(ancestor).backgroundColor;
                        itemImg3.style.backgroundColor = ancestorBgColor;
                    };
                    syncBgColor();

                    const observer = new MutationObserver((mutations) => {
                        mutations.forEach((mutation) => {
                            if (mutation.attributeName === 'style') {
                                syncBgColor();
                            }
                        });
                    });

                    observer.observe(ancestor, {
                        attributes: true,
                        attributeFilter: ['style'],
                    }); 
                }
            }

            // layout5 mobile animation
            const richtextLayout5 = this.$el.querySelector('#richtext-layout5');
            if (richtextLayout5 && this.isMobileSize) {
                this.animationEffects = this.animationList.map(item => ({
                    ...item,
                    enable: false
                }))
            }

            // layout6 mobile animation
            const richtextLayout6 = this.$el.querySelector('#richtext-layout6');
            // layout13 mobile animation
            const richtextLayout13 = this.$el.querySelector('#richtext-layout13');
            if ((richtextLayout6 || richtextLayout13) && this.isMobileSize) {
                this.animationEffects = [
                    { name: 'shift-right', selector: '.item-text', enable: this.showAnimationEffects },
                    { name: 'fade-in', duration: 1500, selector: '.item-img', enable: this.showAnimationEffects }
                ]
            }

            // layout15 mobile animation
            const richtextLayout15 = this.$el.querySelector('#richtext-layout15');
            if (richtextLayout15 && this.isMobileSize) {
                this.animationEffects = this.animationList.map(item => ({
                    ...item,
                    name: 'shift-right',
                    enable: this.showAnimationEffects
                }))
            }
        });    
    }
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
.md-content.richtext {
    p,
    h1,
    h2,
    ul,
    ol,
    figure,
    li {
        padding: revert;
    }
    ul,
    li {
        list-style: revert;
    }
    a {
        color: #00e;
    }
    img {
        max-width: 100%;
        height: auto;
        object-fit: cover;
    }
    table {
        img {
            max-width: initial;
        }
    }
    iframe {
        max-width: 100%;
    }
    .help-container {
        padding: 40px 0 !important;
        @media (max-width: 800px) {
            padding: 20px 0 !important;
        }
    }
    .rich-text-wrapper {
        .md-default-page-content {
            overflow: hidden;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
        }
        .banner-background {
            position: relative;
            overflow: hidden;
            width: 50%;
            min-width: 300px;
            .banner-background-img {
                height: 100%;
                width: 100%;
                object-fit: cover;
            }
            @media (max-width: 600px) {
                width: 100%;
                min-width: auto;
            }
        }
        .rich-text-content-words {
            padding-left: 30px;
            width: 50%;
            min-width: 300px;
            @media (max-width: 600px) {
                padding-left: 0;
                width: 100%;
                min-width: auto;
            }
            .rich-text-content-title {
                font-size: 18px;
                line-height: 24px;
                margin-bottom: 19px;
                color: #202437;
                font-family: var(--mg-title-font);
            }
            .rich-text-content-des {
                font-size: 14px;
                line-height: 20px;
                color: #797e8b;
                margin-bottom: 20px;
                font-family: var(--font-normal);
            }
            .rich-text-content-info {
                font-size: 14px;
                line-height: 20px;
                color: #797e8b;
                margin-bottom: 20px;
                font-family: var(--font-bold);
            }
        }
    }

    @include media-600 {
        .rich-text-wrapper {
            img {
                width: 100% !important;
                height: auto !important;
            }
        }
    }
}
</style>
